import { Card, Col, Row, Spin } from 'antd';
import { Link } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { BACKEND_URL } from '../Backend'; 
import axios from 'axios';


const cookies = new Cookies();
const { Meta } = Card;

function Index() {
  
  const navigation = useNavigate()
  const [carreras, setCarreras] = useState([]);
  const [cargando, setCargando] = useState(false);
  
  // const [imgCarreras, setImgCarreras] = useState([]);

  useEffect(() => {
    if (parseInt(cookies.get('nivel')) !== 4) {
      navigation('/');
      return;
    }

    setCargando(true); // Inicia carga

    // Obtiene carreras desde el backend
    // Hace ambas peticiones con Promise.all para esperar ambas
    Promise.all([
      axios.get(`${BACKEND_URL}/carrerasTSU`),
      axios.get(`${BACKEND_URL}/carrerasING_Y_CDI`),
      axios.get(`${BACKEND_URL}/imgCarreras`)

    ])
     .then(([resTSU, resING_Y_CDI, resImg]) => {
      // Combina ambos arrays con concat o spread
      const todasCarreras = [...resTSU.data, ...resING_Y_CDI.data];
      const imagenes = resImg.data;

        // Asignar imagen a cada carrera si hay match por pk_carrera
        const carrerasConImagen = todasCarreras.map((carrera) => {
          const imagenEncontrada = imagenes.find(
            (img) => img.pk_carrera === carrera.pk_carrera
          );
          return {
            ...carrera,
            img: imagenEncontrada ? imagenEncontrada.img : null,
          };
        });

        setCarreras(carrerasConImagen);
      })
      .catch((error) => {
        console.error('Error al obtener datos:', error);
      }).finally(() => {
      setCargando(false); // Finaliza carga
    });
  }, []);
  
 return (
    <Spin spinning={cargando}>
      <Row gutter={16}>
        {carreras.map((carrera) => (
          <Col key={carrera.pk_carrera} xs={24} sm={12} md={8} lg={6}>
            <Link to={`/carrera/${carrera.pk_carrera}`}>
              <Card
                variant="outlined" 
                cover={
                  carrera.img ? (
                    <img alt={carrera.nombre} src={`${BACKEND_URL}${carrera.img}`} />
                  ) : null
                }
              >
                <Meta title={carrera.nombre} />
              </Card>
              <br /><br />
            </Link>
          </Col>
        ))}
      </Row>
    </Spin>
  );
}

export default Index;
